export default __webpack_public_path__ + "static/media/click.4eefcaae.svg";